import clsx from "clsx";
import { node, oneOf, string } from "prop-types";

import classes from "./ScrollerPanel.module.scss";

export const OVERFLOW_DIRECTIONS = Object.freeze({
  BOTH: "both",
  X: "x",
  Y: "y",
});

const ScrollerPanel = ({
  children,
  className,
  overflowDirection = OVERFLOW_DIRECTIONS.Y,
  wrapperClassName,
}) => {
  return (
    <div
      className={clsx(
        classes.wrapper,
        classes[`direction-${overflowDirection}`],
        wrapperClassName
      )}
    >
      <div className={clsx(classes.scroller, className)}>{children}</div>
    </div>
  );
};

ScrollerPanel.propTypes = {
  children: node,
  className: string,
  overflowDirection: oneOf(Object.values(OVERFLOW_DIRECTIONS)),
  wrapperClassName: string,
};

export default ScrollerPanel;
